import React from 'react';
import { motion } from 'framer-motion';
const costs = [{
  sin: 'Noches buscando en Google sin resultados',
  coste: 'Horas de tu vida que no vuelven'
}, {
  sin: 'Hijo sin progreso visible',
  coste: 'Frustración acumulada — vínculo dañado'
}, {
  sin: 'Mañanas en guerra por las rutinas',
  coste: 'Energía quemada — día arruinado antes de las 9h'
}, {
  sin: 'Sin sistema para los deberes',
  coste: 'Tardes de 3 horas que acaban en llanto'
}, {
  sin: 'Sin herramientas para el colegio',
  coste: 'Reuniones con el tutor sin argumentos'
}, {
  sin: 'Sin protocolo para las crisis',
  coste: 'Reaccionas en lugar de actuar — más culpa'
}, {
  sin: 'Sin vínculo reparado',
  coste: 'El mismo ciclo el año que viene'
}];
export function CostOfInaction() {
  return <section className="bg-navy text-white py-12 px-6" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <div className="text-center mb-8" data-id="element-41">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gold mb-3" data-id="element-42">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 rounded-2xl border border-white/10 overflow-hidden mb-8" data-id="element-43">
          <div className="overflow-x-auto" data-id="element-44">
            <table className="w-full text-left border-collapse" data-id="element-45">
              <thead data-id="element-46">
                <tr className="bg-white/10" data-id="element-47">
                  <th className="p-4 font-bold text-white w-1/2" data-id="element-48">
                    Sin MegaPack
                  </th>
                  <th className="p-4 font-bold text-gold w-1/2" data-id="element-49">Coste real</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10" data-id="element-50">
                {costs.map((row, i) => <tr key={i} className="hover:bg-white/5 transition-colors" data-id="element-51">
                    <td className="p-4 text-gray-300" data-id="element-52">{row.sin}</td>
                    <td className="p-4 font-medium text-white" data-id="element-53">{row.coste}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <div className="text-center" data-id="element-54">
          <p className="text-2xl text-gray-300 mb-2" data-id="element-55">
            El próximo lunes puede ser diferente.
          </p>
          <p className="font-display text-3xl md:text-4xl font-bold text-gold italic" data-id="element-56">
            "La próxima mañana puede ser la mejor que habéis tenido." 💪
          </p>
        </div>
      </div>
    </section>;
}